import script from "./otp.vue?vue&type=script&setup=true&lang=js"
export * from "./otp.vue?vue&type=script&setup=true&lang=js"

import "./otp.vue?vue&type=style&index=0&id=26b3ee55&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b3ee55"]])

export default __exports__